/* eslint-disable react/forbid-prop-types */
import React from 'react';
import DateTimePicker from 'react-datetime-picker';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './DateTimePickerComponent.scss';

const DateTimePickerComponent = ({
    value,
    onChange,
    className,
    disabled,
    format,
}) => {
    let date = value;

    if (typeof value === 'string' && value.length > 0) {
        // Parse the date string
        date = new Date(value);

        // Ensure that the first two digits of the year are '20'
        const year = date.getFullYear();
        if (year < 100) {
            date.setFullYear(2000 + year);
        }
        //  // Ensure that the year does not exceed the current year
        //  const currentYear = new Date().getFullYear();
        //  if (date.getFullYear() > currentYear) {
        //      date.setFullYear(currentYear);
        //  }
    }

    if (!date?.getTime || Number.isNaN(date.getTime())) {
        date = '';
    }
    return (
        <DateTimePicker
            className={classNames(className, 'date-time-picker-component')}
            disableClock
            value={date}
            // clearIcon={false}
            onChange={onChange}
            format={format}
            disabled={disabled}
        />
    );
};

DateTimePickerComponent.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.any,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    format: PropTypes.string,
};

DateTimePickerComponent.defaultProps = {
    className: '',
    value: '',
    disabled: false,
    format: 'dd-MM-yyyy',
};

export default DateTimePickerComponent;
